import { component as defineComponent } from 'flightjs';

var NotificationsCountData = function() {
    this.after('initialize', function() {
        this.on(this.$node, 'uiNeedsNotificationsCount', this.getNotificationCount);
    });

    this.getNotificationCount = function(e, data) {
        var url = this.$node.data('url');
        var xhr = $.get(url);
        var self = this;

        xhr.done(function(res) {
            self.trigger(self.$node, 'dataNotificationsCount', { count: (res && res.count) || 0 });
        });
    };
};

export default defineComponent(NotificationsCountData);



// WEBPACK FOOTER //
// ./src/web/js/contest/data/notifications-count.js